/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './FddFinalCta.module.scss';

export const FddFinalCta = () => {
  const { t } = useInt();

  return (
    <Section background="#FFFFFF" className={styles.root}>
      <div className={styles.inner}>
        <TitleBlock
          title={t('Start with a company you are looking at this week.')}
          description={t(
            'Bring one private company you are assessing. We will pull its filed accounts, its ten-year history and the group around it, live.',
          )}
        />
        <div className={styles.actions}>
          <Button type="blue" size="xl" href="/book-a-demo">
            {t('Book a live review')}
          </Button>
        </div>
      </div>
    </Section>
  );
};
